
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import router from "@/router";
import {UserAuth} from "@/models/UserAuth";


@Component({
  name: "PerfilUsuario",
})

export default class PerfilUsuario extends Vue {
  @Prop() usuarioEdit!: any
  @Prop() dialog!: boolean

  private globalStore = globalStore();
  private consultorioStore = useConsultorioStore();
  private consultorioService = consultorioService.getInstance();
  private tab:any = null;
  
  usuario_seleccionado = '';
  
  usuario= {
      id: null,
      name: '',
      email: '',
      nombre_consultorio: '',
      color_header: '',
  }
	password = '';
	password_repeated = '';
  valid = true;
  fecha = DateTime.now().toFormat('yyyy-MM-dd');
  get user(): UserAuth {
    return this.globalStore.user;
  }
  mounted(){
    //this.getTratamientos();
	this.cargarDatos();
  }
  
  guardar(){
    if (!this.$refs.form.validate()) {
      Alert.warning( `Llene todos los campos obligatorios (*)`)
        return;
      }
      Alert.confirm(`Se actualizaran los datos del usuario ${this.usuario.name} `, 'Actualizar datos?').then(async result => {
        if(result.isConfirmed){
          await this.consultorioService.actualizarUsuario(this.usuario).then(response =>{
            //this.limpiar()
            //router.push({name: 'pacientes'});
          })
        }
      })
    }
  

  limpiar(){
    this.usuario= {
      id: null,
      name: '',
      email: '',
      nombre_consultorio: '',
      color_header: '',
    }
  }
	cargarDatos() {
		this.usuario.name = this.user.name;
		this.usuario.email = this.user.email;
		this.usuario.nombre_consultorio = this.user.nombre_consultorio;
		this.usuario.color_header = this.user.color_header?this.user.color_header:'';
		this.usuario.id = this.user.id;

	}
  get loading(): boolean {
    return this.consultorioStore.loading;
  }
}

